/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React, {useContext, useEffect, useRef, useState} from 'react';

import {AppContext} from '../misc/appContext';

import {PlatformUpdate} from '../../util/interfaces';

import {getUpdatesFrom} from '../../util/updateUtil';

import Updates from './updates';

import {hasAdminLogin} from '../../util/adminUtil';

import {getFromAppLocal} from '../../util/storageUtil';

import User from '../../models/userModel';

import {onPopupClosed, requestOpenPopup} from '../../util/popupUtil';

export default function UpdateController() {
    const context = useContext(AppContext);
    const [active, setActive] = useState(false);
    const [updates, setUpdates] = useState(new Array<PlatformUpdate>());
    const popupId = useRef('');

    function onClose() {
        setActive(false);
        onPopupClosed(popupId.current);
    }

    function onActivate(user: User, updates: Array<PlatformUpdate>) {
        return function () {
            if (!hasAdminLogin()) {
                user.setFlex('lastNotifiedUpdate', updates[0].date.format('YYYY-MM-DD'));
                user.update();
            }
            setUpdates(updates);
            setActive(true);
        };
    }

    useEffect(() => {
        if (getFromAppLocal('newUser') === true) return;
        const {user} = context.userContext;
        if (!user) return;
        const updates = getUpdatesFrom(user, onClose);
        if (!updates.length) return;
        popupId.current = requestOpenPopup(onActivate(user, updates));
        return function () {
            onPopupClosed(popupId.current);
        };
    }, []);

    return <Updates onClose={onClose} updates={updates} active={active} />;
}
